{
  "AUDIT_LOGS": {
    "HEADER": "Audit Logs",
    "HEADER_BTN_TXT": "Audit-logs toevoegen",
    "LOADING": "Ophalen van Audit Logs",
    "DESCRIPTION": "Audit Logs maintain a record of activities in your account, allowing you to track and audit your account, team, or services.",
    "LEARN_MORE": "Learn more about audit logs",
    "SEARCH_404": "Er zijn geen items die overeenkomen met deze zoekopdracht",
    "SIDEBAR_TXT": "<p><b>Audit Logs</b> </p><p> Audit Logs zijn sporen voor gebeurtenissen en acties in een systeem. </p>",
    "LIST": {
      "404": "Er zijn geen Audit Logs beschikbaar in dit account.",
      "TITLE": "Beheer Audit Logs",
      "DESC": "Audit Logs zijn sporen voor gebeurtenissen en acties in het systeem.",
      "TABLE_HEADER": {
        "ACTIVITY": "User",
        "TIME": "Tijd",
        "IP_ADDRESS": "IP-adres"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "AuditLogs succesvol opgehaald",
      "ERROR_MESSAGE": "Kan geen verbinding maken met Woot Server, probeer het later opnieuw"
    },
    "DEFAULT_USER": "Systeem",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} created a new automation rule (#{id})",
      "EDIT": "{agentName} updated an automation rule (#{id})",
      "DELETE": "{agentName} deleted an automation rule (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} heeft {invitee} uitgenodigd voor het account als een {role}",
      "EDIT": {
        "SELF": "{agentName} heeft zijn {attributes} gewijzigd naar {values}",
        "OTHER": "{agentName} heeft {attributes} van {user} gewijzigd naar {values}",
        "DELETED": "{agentName} changed {attributes} of a deleted user to {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} created a new inbox (#{id})",
      "EDIT": "{agentName} updated an inbox (#{id})",
      "DELETE": "{agentName} deleted an inbox (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} created a new webhook (#{id})",
      "EDIT": "{agentName} updated a webhook (#{id})",
      "DELETE": "{agentName} deleted a webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} is ingelogd",
      "SIGN_OUT": "{agentName} heeft zich afgemeld"
    },
    "TEAM": {
      "ADD": "{agentName} created a new team (#{id})",
      "EDIT": "{agentName} updated a team (#{id})",
      "DELETE": "{agentName} deleted a team (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} created a new macro (#{id})",
      "EDIT": "{agentName} updated a macro (#{id})",
      "DELETE": "{agentName} deleted a macro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} added {user} to the inbox(#{inbox_id})",
      "REMOVE": "{agentName} removed {user} from the inbox(#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} added {user} to the team(#{team_id})",
      "REMOVE": "{agentName} removed {user} from the team(#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} updated the account configuration (#{id})"
    },
    "CONVERSATION": {
      "ADD": "{agentName} heeft een gesprek aangemaakt (#{id})",
      "EDIT": "{agentName} heeft een gesprek bijgewerkt (#{id}): {changes}"
    },
    "CONTACT": {
      "ADD": "{agentName} heeft een contact aangemaakt (#{id})",
      "EDIT": "{agentName} heeft een contact bijgewerkt (#{id}): {attributes}"
    }
  }
}
